import { useEffect } from 'react';

interface AffiliateModalProps {
  onClose: () => void;
}

const affiliates = [
  {
    name: 'Lounge華',
    nameEn: 'Lounge Hana',
    instagram: 'https://www.instagram.com/lounge_hana0915/',
    website: 'https://lounge-snack-hana.pages.dev/',
    handle: '@lounge_hana0915',
    image: 'https://readdy.ai/api/search-image?query=elegant%20lounge%20bar%20interior%20with%20warm%20lighting%2C%20floral%20decorations%2C%20sophisticated%20Japanese%20hostess%20bar%20atmosphere%2C%20soft%20pink%20and%20gold%20tones%2C%20luxurious%20seating%2C%20minimalist%20clean%20background&width=400&height=200&seq=affiliate1&orientation=landscape',
  },
  {
    name: '𝓐𝒆𝒅𝒆𝒍-エーデル-',
    nameEn: 'Aedel',
    instagram: 'https://www.instagram.com/aedel2024.07.12/',
    website: 'https://bar-aedel.pages.dev/',
    handle: '@aedel2024.07.12',
    image: 'https://readdy.ai/api/search-image?query=stylish%20modern%20bar%20lounge%20interior%20with%20elegant%20lighting%2C%20sophisticated%20atmosphere%2C%20Japanese%20girls%20bar%20aesthetic%2C%20teal%20and%20dark%20tones%2C%20premium%20seating%20area%2C%20clean%20simple%20background&width=400&height=200&seq=affiliate2&orientation=landscape',
  },
];

export default function AffiliateModal({ onClose }: AffiliateModalProps) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKey);
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-4"
      style={{ background: 'rgba(0,0,0,0.55)' }}
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-xl max-h-[85vh] overflow-y-auto rounded-lg bg-white"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal header */}
        <div
          className="sticky top-0 z-10 flex items-center justify-between px-6 py-4"
          style={{ background: '#AAC4DC' }}
        >
          <div className="flex items-baseline gap-3">
            <h3
              className="text-white text-lg font-medium tracking-widest"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              系列店舗
            </h3>
            <span className="text-white/60 text-xs tracking-wider">AFFILIATE STORES</span>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full cursor-pointer transition-colors"
            style={{ background: 'rgba(255,255,255,0.2)', color: '#fff' }}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLButtonElement).style.background = 'rgba(255,255,255,0.35)';
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLButtonElement).style.background = 'rgba(255,255,255,0.2)';
            }}
          >
            <i className="ri-close-line text-base" />
          </button>
        </div>

        {/* Modal body */}
        <div className="px-6 py-6 flex flex-col gap-5">
          {affiliates.map((store) => (
            <div
              key={store.name}
              className="rounded-lg overflow-hidden"
              style={{ border: '1px solid rgba(170,196,220,0.4)' }}
            >
              {/* Store image */}
              <div className="relative overflow-hidden" style={{ height: '160px' }}>
                <img
                  src={store.image}
                  alt={store.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.3)' }} />
                <div className="absolute bottom-0 left-0 w-full px-4 py-3">
                  <p
                    className="text-white text-base font-medium tracking-widest"
                    style={{ fontFamily: "'Noto Serif JP', serif" }}
                  >
                    {store.name}
                  </p>
                  <p className="text-white/60 text-xs tracking-wider mt-0.5">{store.nameEn}</p>
                </div>
              </div>

              {/* Instagram link */}
              <div className="px-4 py-4 flex flex-col gap-3" style={{ background: 'rgba(170,196,220,0.06)' }}>
                <div className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-instagram-line text-base" style={{ color: '#AAC4DC' }} />
                  </div>
                  <span className="text-sm text-gray-500 tracking-wide">{store.handle}</span>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  <a
                    href={store.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 py-2.5 rounded-lg text-sm tracking-widest font-medium transition-opacity hover:opacity-80 cursor-pointer whitespace-nowrap"
                    style={{ background: '#AAC4DC', color: '#fff', fontFamily: "'Noto Serif JP', serif" }}
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-instagram-line text-sm" />
                    </div>
                    Instagramを見る
                  </a>
                  <a
                    href={store.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 py-2.5 rounded-lg text-sm tracking-widest font-medium transition-colors cursor-pointer whitespace-nowrap"
                    style={{
                      background: '#fff',
                      color: '#6B8095',
                      border: '1px solid rgba(170,196,220,0.8)',
                      fontFamily: "'Noto Serif JP', serif",
                    }}
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-external-link-line text-sm" />
                    </div>
                    公式サイト
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
